import React from 'react';
// template components
import Accordion from '@nmx/template/dist/componentLibrary/modules/Accordion';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import MinusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/MinusSignFill';
import PlusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/PlusSignFill';

export default () => (
  <SectionContainer
    id='commentary-disclosure-other-investment-related-terms' // '-section-container' will be appended dynamically
    backgroundVariant='lightA'
    themeType='lightTheme'
    moduleName='faq-module'
    moduleVariation='A'
    disableBottomPadding>
    <Row align='center'>
      <Col
        align='center'
        medium={10}
        large={8}>
        <Typography
          component='h2'
          nextElement='typography'>
          Other Investing <WidowBlock>Related Terms</WidowBlock>
        </Typography>
        <Typography
          align='left'
          nextElement='graphic'>
          These are terms that are used frequently in market updates so we thought it would be important to explain them a little further to help you better understand what they mean.
        </Typography>
      </Col>
    </Row>
    <Row align='center'>
      <Col
        medium={10}
        large={8}>
        <Accordion
          id='commentary-disclosure-other-investment-related-terms-accordion'
          variant='secondary'
          toggleOpenIcon={PlusSignFillIcon}
          toggleCloseIcon={MinusSignFillIcon}
          isFAQ
          addFAQPageSchemaItemType={false}
          items={[
            {
              id: 'commentary-disclosure-other-investment-related-terms-accordion-index',
              title: 'Index',
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  An index is a common way to measure market performance; however, it is not something you can invest in directly. All index references and performance calculations are based on information provided through Bloomberg. Bloomberg is a provider of real&#45;time and archived financial and market data, including pricing, trading, analytics and news. Examples of different indexes include: S&#38;P 500, MSCI EAFE, Dow Jones Industrial Average and Barclays Capital US Aggregate Bond Index. There are also indexes that measure prices of different U.S. goods. Examples of that include producer and consumer price indexes.
                </Typography>
              ),
            },
            {
              id: 'commentary-disclosure-other-investment-related-terms-accordion-treasury-note',
              title: 'Treasury Note',
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  A Treasury note is a marketable U.S. government debt security with a fixed interest rate and a maturity between one and 10 years.
                </Typography>
              ),
            },
            {
              id: 'commentary-disclosure-other-investment-related-terms-accordion-gross-domestic-product',
              title: (<>Gross Domestic Product &#40;GDP&#41;</>),
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  Measures the market value of all goods and services produced during a certain period of time.
                </Typography>
              ),
            },
            {
              id: 'commentary-disclosure-other-investment-related-terms-accordion-credit-rating-agencies',
              title: 'Credit Rating Agencies',
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  Standard &#38; Poor&#39;s, Fitch Ratings and Moody&#39;s Investor Services issue credit ratings for the debt of public and private corporations.
                </Typography>
              ),
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);
